import React from "react";
import LegalPage from "./LegalPage";

const TermsConditions = () => {
  return (
    <LegalPage title="Terms & Conditions">
      <p><strong>Last Updated:</strong> 09 September 2025</p>

      <p>
        These Terms & Conditions govern the use of services provided by
        Zolang Nexora Softwares. By accessing our services, you agree to
        these terms.
      </p>

      <h4>1. Business Identity</h4>
      <p>
        Zolang Nexora Softwares is a proprietary enterprise registered
        under the Ministry of MSME, Government of India.
      </p>

      <h4>2. Use of Services</h4>
      <p>
        Users shall not misuse the services or engage in unlawful
        activities while using our website or solutions.
      </p>

      <h4>3. Payments</h4>
      <p>
        Service fees are agreed upon before project initiation. Payments
        once made are non-refundable unless stated otherwise.
      </p>

      <h4>4. Intellectual Property</h4>
      <p>
        All designs, software, logos, and content remain the intellectual
        property of Zolang Nexora Softwares.
      </p>

      <h4>5. Governing Law</h4>
      <p>
        These terms shall be governed by the laws of India. Any disputes
        shall be subject to Tamil Nadu jurisdiction.
      </p>

      <h4>6. Contact</h4>
      <p>
        Email: contact.in.dinesh@gmail.com<br />
        Phone: +91 6382585971
      </p>
    </LegalPage>
  );
};

export default TermsConditions;
